export const onDocumentReady = (callback: () => void) => {
  if (document.readyState === "complete" || document.readyState === "interactive") {
    callback();
  } else {
    document.addEventListener("DOMContentLoaded", callback);
  }
};

export const getVisibleHeightOfElement = (element: HTMLElement) => {
  const rect = element.getBoundingClientRect();
  const windowHeight = window.innerHeight;

  if (rect.bottom <= 0 || rect.top >= windowHeight) {
    return 0;
  }

  const visibleTop = Math.max(0, rect.top);
  const visibleBottom = Math.min(windowHeight, rect.bottom);
  return visibleBottom - visibleTop;
};

export interface ElementObserverOptions extends IntersectionObserverInit {
  offsetPx?: number;
  triggerOnce?: boolean; // If true, will only trigger once
}
export const elementObserver = (target: Element, options: ElementObserverOptions, callback: IntersectionObserverCallback): IntersectionObserver => {
  // Handle offset if provided
  if (options.offsetPx) {
    const rootMargin = `${options.offsetPx}px 0px ${options.offsetPx}px 0px`;
    options = {
      ...options,
      rootMargin
    };
  }

  // Track if we've triggered for triggerOnce option
  let hasTriggered = false;

  // Wrap the callback to handle triggerOnce
  const wrappedCallback: IntersectionObserverCallback = (entries, observer) => {
    entries.forEach((entry) => {
      if (options.triggerOnce) {
        if (entry.isIntersecting && !hasTriggered) {
          hasTriggered = true;
          callback([entry], observer);
          // Optionally disconnect the observer since we don't need it anymore
          observer.disconnect();
        }
      } else {
        callback([entry], observer);
      }
    });
  };

  const observer = new IntersectionObserver(wrappedCallback, options);
  observer.observe(target);
  return observer;
};
